import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "test" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { style: {"color":"#f59a23 !important"} }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  class: "ub ub-ac ub-ps",
  style: {"color":"#333"}
}
const _hoisted_6 = { style: {"width":"60px","white-space":"nowrap"} }
const _hoisted_7 = {
  key: 0,
  style: {"color":"#2f7bff","margin-left":"2px","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"},
  class: "theme-color"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_v_nodes = _resolveComponent("v-nodes")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_plus_outlined = _resolveComponent("plus-outlined")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_select, {
      disabled: _ctx.disabled,
      multiple: false,
      placeholder: _ctx.placeholder,
      value: _ctx.selectValue,
      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectValue) = $event)),
      "allow-clear": "",
      "show-search": "",
      optionFilterProp: "title",
      onChange: _ctx.onChange,
      onSearch: _ctx.onSearch,
      virtual: false,
      onDropdownVisibleChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addText = ''))
    }, {
      dropdownRender: _withCtx(({ menuNode: menu }) => [
        _createVNode(_component_v_nodes, { vnodes: menu }, null, 8, ["vnodes"]),
        _createVNode(_component_a_divider, { style: {"margin":"4px 0"} }),
        _createElementVNode("div", {
          style: {"padding":"4px 12px","cursor":"pointer"},
          onMousedown: _cache[0] || (_cache[0] = (e) => e.preventDefault()),
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addProject && _ctx.addProject(...args)))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_plus_outlined),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.tips), 1),
            (_ctx.addText)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "”" + _toDisplayString(_ctx.addText) + "“", 1))
              : _createCommentVNode("", true)
          ])
        ], 32)
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.records, (item) => {
          return (_openBlock(), _createBlock(_component_a_select_option, {
            key: item.id,
            value: item.id,
            title: item.name
          }, {
            default: _withCtx(() => [
              (item?.name?.indexOf(_ctx.inpuText) > -1 && _ctx.inpuText != '')
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                    _createTextVNode(_toDisplayString(item.name.substr(0, item?.name?.indexOf(_ctx.inpuText))), 1),
                    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.inpuText), 1),
                    _createTextVNode(_toDisplayString(item.name.substr(item?.name?.indexOf(_ctx.inpuText) + _ctx.inpuText.length)), 1)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(item.name), 1))
            ]),
            _: 2
          }, 1032, ["value", "title"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["disabled", "placeholder", "value", "onChange", "onSearch"])
  ]))
}